import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Avatar,
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  TextField,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Alert,
  Chip,
  useTheme, ListItemIcon, ListItemText, Divider
} from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShareIcon from "@mui/icons-material/Share";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import defaultCover from "../../assets/defaultCover.png";
import ReportIcon from "@mui/icons-material/Report";
import BookmarkIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkAddedIcon from "@mui/icons-material/Bookmark";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import useAuth from "app/hooks/useAuth";
import { GetOpportunities } from "app/redux/slice/getSlice";
import { useDispatch } from "react-redux";
import { captions, typography } from "app/utils/constant";
import JobDetails from "app/views/Account/AppyJob";

const validationSchema = Yup.object({
  selection: Yup.string().required("Please select an option"),
  // reason: Yup.string().when("selection", {
  //   is: "6",
  //   then: Yup.string().required("Please provide a reason"),
  //   otherwise: Yup.string(),
  // }),
});

export default function CastingCard({
  data,
  hideImage,
  addFollowing,
  removeFollowing,
  isBlocked,
  onClose,
  onReport,
  onBlock,
  reportDialog,
  reportOptions,
  onReportSubmit,
  onAddBookmark,
  onRemoveBookmark,
  onFollowChange,
  onMediaClick,
}) {
  const dispatch = useDispatch();
  const { user } = useAuth();
  console.log(user, "--find login userID");
  
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openBlockConfirm, setOpenBlockConfirm] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(data.IsBookmarked || false);
  const [isfollow, setIsfollow] = useState(data.IsFollowing || false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("warning"); // or "error"

  const [selectedJob, setSelectedJob] = useState(null);
console.log("onClick={() => setSelectedJob(data)}",selectedJob);
  const handleReportCancel = (resetForm) => {
    // resetForm(); 
    //   Close dialog without calling submit
    if (reportDialog.open) {
      onReportSubmit({ cancel: true });
    }
  };
  const LanguageChips = ({ languages }) => {
    const maxVisible = 2;
    const visibleLangs = languages.slice(0, maxVisible);
    const remainingCount = languages.length - maxVisible;

    return (
      <Stack direction="row" spacing={1}>
        {visibleLangs.map((lang, index) => (
          <Chip
            key={index}
            label={lang}
            variant="outlined"
            sx={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0em",
              textAlign: "center",
              color: theme.palette.info.main,

            }}
          />


        ))}
        {remainingCount > 0 && (
          <Chip label={`+${remainingCount}`} variant="outlined" sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "0em",
            color: theme.palette.primary.contrastText,
          }} />
        )}
      </Stack>
    );
  };
let sourceType = "";
let sourceColor = "";

switch (data.SourceType) {
  case "IN":
    sourceType = "Internship";
    sourceColor = theme.palette.warning.main;
    break;

  case "AP":
    sourceType = "Apprenticeship";
    sourceColor = "purple";
    break;

  case "GW":
    sourceType = "Gig";
    sourceColor = "#2979ff";
    break;

  case "JC":
    sourceType = "Job";
    sourceColor = "grey";
    break;

  default:
    sourceType = "Unknown";
    sourceColor = "grey";
    break;
}
  return (
    <>
    <Card
  // sx={{
  //   display: "flex",
  //   flexDirection: data.ProfileImage ? "row" : "column",
  //   maxWidth: 650,
  //   width:650,
  //   borderRadius: 4,
  //   boxShadow: 2,
  //   margin: "auto", 
  //   position: "relative",
  //   bgcolor: theme.palette.card,
  //   border: `1px solid ${theme.palette.border}`,
  //   overflow: "hidden",
  // }}
  sx={{
    display: "flex",
    flexDirection: {
      xs: "column",   // 📱 mobile
      sm: "column",   // 📱 tablet
      md: "row",      // 💻 desktop
    },
    width: "100%",
    maxWidth: { md: 650 },
    borderRadius: 4,
    boxShadow: 2,
    mx: "auto",
    position: "relative",
    bgcolor: theme.palette.card,
    border: `1px solid ${theme.palette.border}`,
    overflow: "hidden",
  }}
>
  {/* Left Media */}

{/* ✅ Show image only when card is NOT selected */}

{!hideImage  && data.SourceType === "JC" ? (
  <>
   <CardMedia
    component="img"
    image={defaultCover}
    alt="Gig Image"
    // sx={{
    //   width: { xs: "100%", sm: 180 },
    //   height: { xs: 180, sm: "auto" },
    //   objectFit: "cover",
    //   cursor: "pointer",
    //   transition: "all 0.3s ease",
    //   borderRadius: 2,
    // }}
    sx={{
    width: {
      xs: "100%",   // 📱 full width
      md: 180,      // 💻 left image
    },
    height: {
      xs: 180,
      md: "auto",
    },
    objectFit: "cover",
    cursor: "pointer",
  }}
    onClick={() => {
      onMediaClick(); // 👈 triggers parent setSelectedJob(item)
    }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = defaultCover;
    }}
  />
  </>
  ):(
    <>
{!hideImage  && (data.ReferenceImage || data.CoverImage) && (
  <CardMedia
    component="img"
    // image={data.ReferenceImage || data.CoverImage || defaultCover}
    image={data.ReferenceImage || defaultCover}
    alt="Gig Image"
    sx={{
    width: {
      xs: "100%",   // 📱 full width
      md: 180,      // 💻 left image
    },
    height: {
      xs: 180,
      md: "auto",
    },
    objectFit: "cover",
    cursor: "pointer",
  }}
    // sx={{
    //   width: { xs: "100%", sm: 180 },
    //   height: { xs: 180, sm: "auto" },
    //   objectFit: "cover",
    //   cursor: "pointer",
    //   transition: "all 0.3s ease",
    //   borderRadius: 2,
    // }}
    onClick={() => {
      onMediaClick(); // 👈 triggers parent setSelectedJob(item)
    }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = defaultCover;
    }}
  />
  )}
</>
  )}

  {/* Right Content */}
  <Box sx={{ flex: 1, p: { xs: 1.5, sm: 2 },}}>
    {/* Header */}
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        <Avatar
          src={data.ProfileImage}
          alt={data.UserName}
          onClick={() => navigate(`/account/view-profile/${data.UserID}`)}
          sx={{ cursor: "pointer" }}
        />
        <Box ml={2}>
          <Typography sx={typography.h4Bold} color={theme.palette.primary.contrastText}>
            {data.UserName}
          </Typography>
          <Typography sx={typography.bodyMedium} color={theme.palette.info.main}>
            {data.CreatedHours}
          </Typography>
        </Box>
      </Box>

      {/* Gig Source + Menu */}
      <Box display="flex" alignItems="center" gap={1}>
         <Button
      variant="contained"
      size="small"
       sx={{
    ...typography.buttonSecondary,
    borderRadius: 10,
    backgroundColor: sourceColor,
    color: "white",
    textTransform: "capitalize",

    // ✅ responsive sizing
    fontSize: {
      xs: "0.65rem",   // 📱 mobile
      sm: "0.7rem",    // 📱 tablet
      md: "0.75rem",   // 💻 desktop
    },
    px: {
      xs: 1,
      sm: 1.2,
      md: 1.5,
    },
    py: {
      xs: 0.3,
      sm: 0.4,
      md: 0.5,
    },
    minHeight: {
      xs: 22,
      sm: 24,
      md: 28,
    },
  }}
      // sx={{
      //   ...typography.buttonSecondary,
      //   borderRadius: 10,
      //   backgroundColor: sourceColor,
      //   color: "white",
      //   textTransform: "capitalize",
      // }}
      onClick={() => {
        console.log("SourceType", data.SourceType);
      }}
    >
      {sourceType}
    </Button>

    {data.UserID !== user.UserID && (
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        size="small"
        sx={{
          color: "warning.main",
          "&:hover": { color: "warning.dark" },
        }}
      >
        <MoreHorizIcon />
      </IconButton>
    )}
  </Box>
        {/* <Button
          variant="contained"
          size="small"
          sx={{
            ...typography.buttonSecondary,
            borderRadius: 10,
            backgroundColor:
              data.SourceType === "GW"
                ? "#2979ff"
                : data.SourceType === "AP"
                ? "purple"
                : data.SourceType === "IN"
                ? theme.palette.warning.main
                : "grey",
            color: "white",
            textTransform: "capitalize",
          }}
          onClick={()=>{
            console.log("SourceType",data.SourceType)
            // <JobDetails/>
          }}
        >
          {sourceType}
        </Button>
        {data.UserID !== user.UserID && (
          <IconButton
            onClick={(event) => setAnchorEl(event.currentTarget)}
            size="small"
            sx={{
              color: "warning.main",
              "&:hover": { color: "warning.dark" },
            }}
          >
            <MoreHorizIcon />
          </IconButton>
        )}
      </Box> */}
    </Box>

   {/* Menu */}
<Menu
  anchorEl={anchorEl}
  open={open}
  onClose={() => setAnchorEl(null)}
  PaperProps={{
    sx: {
      borderRadius: 2,
      p: 0.5,
      minWidth: 160,     // narrower width
      maxHeight: 260,    // smaller height
      boxShadow: 4,
      "& .MuiMenuItem-root": {
        minHeight: 32,   // reduced item height
        fontSize: "0.85rem",
        px: 1,
      },
      "& .MuiListItemIcon-root": {
        minWidth: 32,    // less space before text
      },
    },
  }}
>
  {/* Follow / Unfollow */}
  <MenuItem
    onClick={async () => {
      const idata = { FollowingUserID: data.UserID };
      try {
        const response = isfollow
          ? await removeFollowing(idata)
          : await addFollowing(idata);

        if (response?.payload?.Status === "Y") {
          setIsfollow(!isfollow);
          onFollowChange?.(data.UserID, !isfollow);
        }
      } catch (err) {
        console.error("Follow error:", err);
      } finally {
        onClose();
      }
    }}
  >
    <ListItemIcon>
      <Avatar sx={{ bgcolor: "primary.main", width: 26, height: 26 }}>
        {isfollow ? <PersonRemoveIcon fontSize="small" /> : <PersonAddIcon fontSize="small" />}
      </Avatar>
    </ListItemIcon>
    <ListItemText primary={isfollow ? "Unfollow User" : "Follow this user"} />
  </MenuItem>

  {/* Bookmark */}
  <MenuItem
    onClick={async () => {
      const idata = {
         UserID: user.UserID,
        // UserID: data.UserID,
        RecordID: data.RecordID,
        Type: data.SourceType,
      };
      try {
        const response = isBookmarked
          ? await onRemoveBookmark(idata)
          : await onAddBookmark(idata);

        if (response?.payload?.Status === "Y") {
          setIsBookmarked(!isBookmarked);
        }
      } catch (err) {
        console.error("Bookmark error:", err);
      } finally {
        onClose();
      }
    }}
  >
    <ListItemIcon>
      <Avatar sx={{ bgcolor: "secondary.main", width: 26, height: 26 }}>
        {isBookmarked ? <BookmarkAddedIcon fontSize="small" /> : <BookmarkIcon fontSize="small" />}
      </Avatar>
    </ListItemIcon>
    <ListItemText primary="Save Profile" />
  </MenuItem>

  {/* Share */}
  <MenuItem
    onClick={() => {
      console.log("Share clicked");
      onClose();
    }}
  >
    <ListItemIcon>
      <Avatar sx={{ bgcolor: "purple", width: 26, height: 26 }}>
        <ShareIcon fontSize="small" />
      </Avatar>
    </ListItemIcon>
    <ListItemText primary="Share" />
  </MenuItem>

  {/* Report */}
  <MenuItem
    onClick={() => {
      onReport();
     // onClose();
    }}
  >
    <ListItemIcon>
      <Avatar sx={{ bgcolor: "error.main", width: 26, height: 26 }}>
        <ReportIcon fontSize="small" />
      </Avatar>
    </ListItemIcon>
    <ListItemText primary="Report user" />
  </MenuItem>
   {/* Block */}
    <MenuItem disabled={isBlocked} 
              onClick={() => { setOpenBlockConfirm(true); setAnchorEl(null); }}
              >
                <BlockIcon sx={{ mr: 1 }} color="error" />
                {isBlocked ? "Blocked User" : "Block User"}
              </MenuItem>
  <Divider sx={{ my: 0.5 }} />

  {/* Cancel */}
  <MenuItem
    onClick={() => setAnchorEl(null)}
    sx={{ justifyContent: "center", fontWeight: 600, fontSize: "0.85rem" }}
  >
    Cancel
  </MenuItem>
</Menu>


    {/* Gig Content */}
    <Box mt={2}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography sx={typography.h4} color={theme.palette.primary.contrastText}>
            {data.Title}
          </Typography>
          <Typography variant="body2" color={theme.palette.info.main}>
            {data.SubTitle}
          </Typography>
        </Box>
        <Typography sx={typography.captionBold} color={theme.palette.text.secondary}>
          Apply by {data.StartDate}
        </Typography>
      </Box>
<Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
      {/* Department */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>
        {data.Designation || "Department"}
      </Typography>

      {/* Dot separator */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>•</Typography>

      {/* Employment type */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>
        {data.WorkType}
      </Typography>

      {/* Dot separator */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>•</Typography>

      {/* Location */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>
        {data.Location}
      </Typography>

      {/* Dot separator */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>•</Typography>

      {/* Experience */}
      <Typography sx={typography.h6} color={theme.palette.text.secondary}>
        {data.Duration}
      </Typography>
    </Box>
      <Typography
        
        color={theme.palette.primary.contrastText}
        sx={{
          ...typography.bodyLarge,
          mt: 1,
          mb: 0.5,
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {data.JobResponsibilities}</Typography>

      <Typography
        
        color={theme.palette.info.main}
        sx={{ ...typography.captionBold,  cursor: "pointer" }}
      >
        See Translation
      </Typography>

      {/* <Typography
        variant="body2"
        sx={{ mt: 1.5, color: theme.palette.secondary.main }}
      >
        {data.Location || "Chennai"} • {data.Experience || "3–5 years experience"}
      </Typography> */}
    </Box>
  </Box>
</Card>

    

      {/* Report Dialog */}
      <Dialog
        open={reportDialog.open && reportDialog.targetUserID === data.UserID}
        onClose={()=>handleReportCancel}
      //onClose={() => onReportSubmit({ cancel: true })}
        PaperProps={{ sx: { width: 500 } }}
      >
        <DialogTitle
          sx={{
            position: "sticky",
            backgroundColor: "#fff",
            borderBottom: "1px solid #eee",
            zIndex: 111111,
            top: 0,
          }}
        >
          Report</DialogTitle>

        <Formik
          initialValues={{ selection: "", reason: "" }}
          // validationSchema={validationSchema}
          onSubmit={(values) => {
            onReportSubmit(values);
          }}
          // onSubmit={onReportSubmit}
        >
          {({ values, handleChange, errors, touched, resetForm }) => (
            <Form>
              <DialogContent >
                <Typography mb={2}>
                  What is the reason for the Reporting?
                </Typography>

                <RadioGroup
                  name="selection"
                  value={values.selection}
                  onChange={handleChange}
                >
                  {reportOptions?.map((option) => (
                    <Paper
                      key={option.RecordID}
                      elevation={0}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                        mb: 2,
                        px: 2,
                        py: 1,
                      }}
                    >
                      <FormControlLabel
                        value={option.RecordID}
                        control={<Radio />}
                        label={
                          <Typography variant="body1">
                            {option.ReasonEn}
                          </Typography>
                        }
                        sx={{ width: "100%", margin: 0 }}
                      />
                    </Paper>
                  ))}
                </RadioGroup>

                {values.selection === "9" && (
                  <Box mt={2}>
                    <TextField
                      fullWidth
                      id="reason"
                      name="reason"
                      variant="outlined"
                      placeholder="Enter your reason"
                      value={values.reason}
                      onChange={handleChange}
                      error={touched.reason && Boolean(errors.reason)}
                      helperText={touched.reason && errors.reason}
                    />
                  </Box>
                )}

                {touched.selection && errors.selection && (
                  <Typography color="error" fontSize={13}>
                    {errors.selection}
                  </Typography>
                )}
              </DialogContent>

              <DialogActions
                sx={{
                  position: "sticky",
                  backgroundColor: "#fff",
                  borderTop: "1px solid #eee",
                  zIndex: 111111,
                  bottom: 0,
                }}
              >
                <Button
                  type="button"
                  onClick={() => handleReportCancel(resetForm)}
                >
                  Cancel
                </Button>
                {/* <Button onClick={() => onReportSubmit({ cancel: true })}>Cancel</Button> */}

                <Button
                sx={{
                        color: theme.palette.buttons.primary.text,
                         bgcolor: theme.palette.buttons.primary.bg,
                         "&:hover": 
                         { color: theme.palette.buttons.primary.text, 
                          bgcolor: theme.palette.buttons.primary.bg, 
                        },
                }}
                 type="submit" 
                 variant="contained"
                 >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* Block Dialog */}
      <Dialog
        open={openBlockConfirm}
        onClose={() => setOpenBlockConfirm(false)}
      >
        <DialogTitle>Confirm Block</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to block this user?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenBlockConfirm(false)} color="inherit">
            No
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onBlock();
              setOpenBlockConfirm(false);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
 // onClick={() => {
      //   if (data.UserID === user.UserID) {
      //     setSnackbarMessage("You cannot view your own job details");
      //     setSnackbarSeverity("warning");
      //     setOpenSnackbar(true);
      //   } else {
      //     if (data.Source === "Gig Works") {
      //       navigate(`/account/apply-job/GW/${data.RecordID}`);
      //     } else if (data.Source === "Apprenticeship") {
      //       navigate(`/account/apply-job/AP/${data.RecordID}`);
      //     } else {
      //       navigate(`/account/apply-job/IN/${data.RecordID}`);
      //     }
      //   }
      // }}
{
  /* <Dialog open={reportDialog.open && reportDialog.targetUserID === data.UserID} onClose={() => { }} PaperProps={{ sx: { width: 500 } }}>
        <DialogTitle>Report</DialogTitle>
        <Formik
          initialValues={{ selection: "", reason: "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            onReportSubmit(values);
      
          }}
        >
          {({ values, handleChange, errors, touched }) => (
            <Form>
              <DialogContent>
                <Typography mb={2}>What is the reason for the Reporting?</Typography>

                <RadioGroup name="selection" value={values.selection} onChange={handleChange}>
                  {reportOptions?.map((option) => (
                    <Paper key={option.RecordID} elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: "12px", mb: 2, px: 2, py: 1 }}>
                      <FormControlLabel
                        value={option.RecordID}
                        control={<Radio />}
                        label={<Typography variant="body1">{option.Reason}</Typography>}
                        sx={{ width: "100%", margin: 0 }}
                      />
                    </Paper>
                  ))}
                </RadioGroup>

                {values.selection === "6" && (
                  <Box mt={2}>
                    <TextField
                      fullWidth
                      id="reason"
                      name="reason"
                      variant="outlined"
                      placeholder="Enter your reason"
                      value={values.reason}
                      onChange={handleChange}
                      error={touched.reason && Boolean(errors.reason)}
                      helperText={touched.reason && errors.reason}
                    />
                  </Box>
                )}

                {touched.selection && errors.selection && (
                  <Typography color="error" fontSize={13}>
                    {errors.selection}
                  </Typography>
                )}
              </DialogContent>


              <DialogActions>
                <Button

//   onClick={() => {
//     onReportSubmit({ cancel: true });
//     navigate(-1);
//   }}
// >
//   Cancel
// </Button> 
             onClick={() => onReportSubmit({ cancel: true })} 
             >Cancel 
                </Button>
                <Button type="submit" variant="contained">Submit</Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog> */
}
  {/* <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
              >
                <Typography variant="h6" fontWeight={700}>
                  {data.Title}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  {data.SubTitle}
                </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                flexWrap="wrap"
                mb={1}
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" alignItems="center">
                    <WorkIcon fontSize="small" color="warning" />
                    <Box ml={1}>
                      <Typography variant="body2">
                        {data.ProjectName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Project
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <CurrencyRupeeIcon fontSize="small" color="warning" />
                    <Box ml={1}>
                      <Typography variant="body2">{data.PriceType}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Price
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" alignItems="center">
                    <WorkIcon fontSize="small" color="warning" />
                    <Box ml={1}>
                      <Typography variant="body2">
                        {data.GigWorkType || data.WorkTypeName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Work Type
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <WorkIcon fontSize="small" color="warning" />
                    <Box ml={1}>
                      <Typography variant="body2">
                        {data.WorkTypeName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Work Method
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box> */}
                {/* <Tooltip title={isBookmarked ? "Remove Bookmark" : "Add Bookmark"}> */}
          {/* <IconButton
              onClick={async () => {
                const idata = {
                  UserID: user.UserID,
                  RecordID: data.RecordID,
                  Type: data.SourceType,
                };

                try {
                  const response = isBookmarked
                    ? await onRemoveBookmark(idata)
                    : await onAddBookmark(idata);

                  if (response?.payload?.Status === "Y") {
                    setIsBookmarked(!isBookmarked);
                  }
                } catch (err) {
                  console.error("Bookmark error:", err);
                }
              }}
              sx={{ position: "absolute", top: 10, right: 10 }}
            >
              {isBookmarked ? (
                <BookmarkAddedIcon color="primary" />
              ) : (
                <BookmarkIcon />
              )}
            </IconButton> */}

          {/* <IconButton onClick={() => setIsBookmarked(!isBookmarked)} sx={{ position: 'absolute', top: 10, right: 10 }}>
              {isBookmarked ? <BookmarkAddedIcon color="primary" /> : <BookmarkIcon />}
            </IconButton> */}
          {/* </Tooltip> */}
           {/* <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
              >
                <Typography variant="h6" fontWeight={700}>
                  {data.Title}
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                  {data.Responsibility}
                </Typography>
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                flexWrap="wrap"
                mb={1}
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" alignItems="center">
                    <WorkIcon fontSize="small" color="warning" />
                    <Box
                      ml={1}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography variant="body2">
                        {data.WorkTypeName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Remote
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <CalendarTodayIcon fontSize="small" color="warning" />
                    <Box
                      ml={1}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography variant="body2">{`${data.StartDate}-${data.Duration}`}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Duration
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" alignItems="center">
                    <WorkIcon fontSize="small" color="warning" />
                    <Box
                      ml={1}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography variant="body2">{data.Title}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        Internship Profile
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box> */}
               {/* <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                elevation: 3,
                sx: { borderRadius: 2, minWidth: 200 },
              }}
            >
              <MenuItem
                onClick={async () => {
                  if (!data?.UserID) {
                    console.error("UserID is missing in data");
                    return;
                  }

                  const idata = {
                    FollowingUserID: data.UserID,
                  };
                  try {
                    const response = isfollow
                      ? await removeFollowing(idata)
                      : await addFollowing(idata);

                    if (response?.payload?.Status === "Y") {
                      setIsfollow((prev) => !prev);
                      onFollowChange?.(data.UserID, !isfollow); // update parent state
                    }
                  } catch (err) {
                    console.error("Follow/Unfollow error:", err);
                  } finally {
                    setAnchorEl(null); // close menu in any case
                  }
                }}
              >
                {isfollow ? (
                  <>
                    <PersonRemoveIcon sx={{ mr: 1 }} />
                    Unfollow User
                  </>
                ) : (
                  <>
                    <PersonAddIcon sx={{ mr: 1 }} />
                    Follow User
                  </>
                )}
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                }}
              >
                <ShareIcon sx={{ mr: 1 }} />
                Share
              </MenuItem>

              <MenuItem
                onClick={() => {
                  onReport();
                  setAnchorEl(null);
                }}
              >
                <ReportIcon sx={{ mr: 1 }} color="error" />
                Report
              </MenuItem>

              <MenuItem disabled={isBlocked} 
              onClick={() => { setOpenBlockConfirm(true); setAnchorEl(null); }}
              >
                <BlockIcon sx={{ mr: 1 }} color="error" />
                {isBlocked ? "Blocked User" : "Block User"}
              </MenuItem>
            </Menu> */}